<script>
    import { onMount } from 'svelte';
    import { first, replace } from '../helpers/navigation.svelte.js';
    import { currentSession } from '../data/session.svelte.js';

    const { route } = $props();

    onMount(() => {
        replace(first());
    });

</script>
